<template>
<div class="canvas-page">
<!--
      :width="windowWidth"
      :height="Math.floor(windowHeight)"
      -->
  <canvas
      id="my-canvas"
      :class="{rotate: rotate}"
      :style="{transform: rotate?`rotate(90deg) translateY(${-windowHeight}px)`:''}"
      @mousedown="mousedown"
      @mousemove="mousemove"
      @mouseup="mouseup"
      @mouseout="mouseup"
      @touchstart="touchstart"
      @touchmove="touchmove"
      @touchend="touchend"
      @click="closeOption"
  ></canvas>
  <div class="tool-bar" :class="{hideBar}">
    <div v-show="!hideBar" class="tool-item">
      <span class="color-circle" style="margin: 0" :style="{backgroundColor: color}" @click="optionType = 'color'"></span>
      <div v-if="optionType === 'color'" class="options" style="width: 230px">
        <span
            class="color-circle"
            v-for="item in colors"
            :key="item"
            :style="{backgroundColor: item === color ? '#fff' : item, borderColor: item === color ? item : '#fff'}"
            :class="{'curr-circle': item === color}"
            @click="setColor(item)"
        ></span>
      </div>
    </div>
    <div class="tool-item">
      <span class="icon pen-icon" @click="penClick" :class="{active: writeType==='pen'}"></span>
      <div v-show="optionType === 'pen'" class="options" style="width: 200px">
        <span
            v-for="item in widthArr"
            :key="item"
            :class="{'curr-pen': item === width}"
            @click="setPen(item)"
        >
          <div class="pen-width" :style="{height: item + 'px'}"></div>
        </span>
      </div>
      <div
          v-show="optionType === null"
          class="options" style="width: 26px;border: none;top: -30px" @click="optionType = 'hideBar';
          hideBar = true">
        <span class="close"></span>
      </div>
    </div>
    <div v-show="!hideBar" class="tool-item">
      <span
          class="icon eraser-icon"
          @click="optionType = 'eraser'; writeType = 'eraser'"
          :class="{active: writeType==='eraser'}"></span>
      <div v-show="optionType==='eraser'" class="options" style="width: 50px">
        <span class="clear" @click="clearCanvas">清空</span>
      </div>
    </div>
  </div>
  <div class="common-share icon" @click="showId"></div>
  <div v-if="creator" class="edit-switch">
    <span>协同编辑</span>
    <el-switch
        v-model="edit"
        class="ml-2"
        active-color="#13ce66"
        inactive-color="#ff4949"
    />
  </div>

  <div id="NewsToolBox" style="height: 0;position: fixed;top: -1px"></div>
</div>
</template>

<script>
import bus from "@/utils/bus";
// import router from "../router";
import url from '../config.js'
export default {
  name: "my-canvas",
  props: {
    creator: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return{
      widthArr: [1, 2, 5, 8],
      width: 2,
      eraserWidth: 20,
      color: '#191919',
      windowWidth: 0,
      windowHeight: 0,
      ctx: null,
      writing: false,
      points: [],
      start: {
        x: 0,
        y: 0
      },
      colors: ['#E84026', '#F7CE00', '#64BB5C', '#46B2E3', '#564AF6', '#AC49F4', '#191919'],
      optionType: null,
      writeType: 'pen',
      hideBar: false,
      freeze: false,
      freezeTimer: null,
      rotate: 0,
      originalZoom: 1,
      edit: false
    }
  },
  computed: {
    canvasId() {
      return this.$store.state.canvasId
    }
  },
  watch: {
    color(n) {
      this.ctx.strokeStyle = n
    },
    width(n) {
      this.ctx.lineWidth = n * this.originalZoom
    },
    writeType(n) {
      if (n === 'pen') {
        this.ctx.strokeStyle = this.color
        this.ctx.lineWidth = this.width
      } else {
        this.ctx.strokeStyle = '#fff'
        this.ctx.lineWidth = this.eraserWidth
      }
    },
    points: {
      handler() {
        const pointsObj = {
          id: this.canvasId,
          value: this.points
        }
        localStorage.setItem('points', JSON.stringify(pointsObj))
      },
      deep: true
    },
    windowWidth: {
      handler(n) {
        const canvas = document.querySelector('#my-canvas')
        if (canvas) {
          setTimeout(() => {
            canvas.width = n
            canvas.height = this.windowHeight
          })
          setTimeout(() => {
            this.ctx = canvas.getContext("2d");
            this.ctx.strokeStyle = this.color
            this.ctx.lineWidth  = this.width
            this.ctx.lineJoin = "round" // 重叠样式
            this.ctx.lineCap = "round" // 断点环境
          }, 100)
        }
      }
    }
  },
  mounted() {
    this.init()
    bus.$on('getWriting', this.getWriting)
    bus.$on('getClear', this.onClear)
    bus.$on('emitPoint', this.emitPoint)
    bus.$on('getPoint', this.getPoint)
  },
  unmounted() {
    bus.$off('getWriting', this.getWriting)
    bus.$off('getClear', this.onClear)
    bus.$off('emitPoint', this.emitPoint)
    bus.$off('getPoint', this.getPoint)
  },
  methods: {
    init() {
      const body = document.querySelector('body')
      this.windowWidth = body.offsetWidth
      this.windowHeight = body.offsetHeight
      this.$nextTick(() => {
        let canvas = document.querySelector('#my-canvas')
        this.ctx = canvas.getContext("2d");
        this.ctx.strokeStyle = this.color
        this.ctx.lineWidth  = this.width
        this.ctx.lineJoin = "round" // 重叠样式
        this.ctx.lineCap = "round" // 断点环境

        // this.ctx.moveTo(200,100);
        // this.ctx.lineTo(200,101);
        // this.ctx.stroke();
        // console.log(this.ctx)
        // bus.$on('pointChange', this.pointChange)
      })
    },
    mousedown(e) {
      if (this.freeze) {
        return
      }
      console.log('mousedown', e)
      e = e || event
      e.preventDefault()
      let obj = {
        x: e.offsetX,
        y: e.offsetY,
        type: 'start',
        color: this.writeType === 'pen' ? this.color : '#fff',
        width: this.writeType === 'pen' ? this.width : 20,
      }
      this.drawStart(obj)
    },
    mousemove(e) {
      // console.log(e.offsetX, e.offsetY)
      if (this.freeze) {
        return
      }
      if (!this.writing) return
      e = e || event
      e.preventDefault()
      let obj = {
        x: e.offsetX,
        y: e.offsetY
      }
      this.drawing(obj)
    },
    mouseup(e) {
      if (this.freeze) {
        return
      }
      e = e || event
      e.preventDefault()
      if (e.type === 'mouseout') {
        this.writing = false
        return
      }
      let obj = {
        x: e.offsetX,
        y: e.offsetY,
        type: 'end'
      }
      this.drawEnd(obj)
    },
    getDistance(point1, point2) {
      const x = Math.abs(point1.x - point2.x)
      const y = Math.abs(point1.y - point2.y)
      return Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2))
    },
    drawStart(point, emit) {
      // if (this.writeType === 'eraser') {
      //   this.removePoint(point)
      // }
      if (!emit) {
        this.emitWriting(point, 'start', this.optionType)
      }
      if (point.color) {
        this.ctx.strokeStyle = point.color
      }
      if (point.width) {
        this.ctx.lineWidth = point.width
      }
      // console.log(point)
      this.writing = true
      this.start.x = point.x
      this.start.y = point.y
      this.ctx.beginPath();
      this.ctx.moveTo(this.start.x, this.start.y);
      this.ctx.lineTo(point.x, point.y);
      this.ctx.stroke();
      this.ctx.closePath();
      point.type = 'start'
      this.points.push(point);
    },
    drawing(point, emit) {
      // console.log(point)
      // if (this.writeType === 'eraser') {
      //   this.removePoint(point)
      // }
      if (!emit) {
        this.emitWriting(point, 'writing', this.optionType)
      }
      this.ctx.beginPath();
      this.ctx.moveTo(this.start.x, this.start.y);
      this.ctx.lineTo(point.x, point.y);
      this.ctx.stroke();
      this.ctx.closePath();
      point.type = 'writing'
      this.points.push(point)
      this.start.x = point.x
      this.start.y = point.y
    },
    drawEnd(point, emit) {
      console.log('end', point)
      if (!emit){
        this.emitWriting(point, 'end', this.optionType)
      }

      if (point) {
        point.type = 'end'
        this.points.push(point)
      }
      this.writing = false

    },
    touchstart(e) {
      if (this.freeze) {
        return
      }
      this.closeOption()
      e.preventDefault()
      if (e.touches && e.touches.length > 0) {
        let obj = {
          x: e.touches[0].pageX,
          y: e.touches[0].pageY,
          type: 'start',
          color: this.writeType === 'pen' ? this.color : '#fff',
          width: this.writeType === 'pen' ? this.width : 20,
        }
        if (this.rotate) {
          obj.x = e.touches[0].pageY
          obj.y = this.windowHeight - e.touches[0].pageX
        }
        this.drawStart(obj)
      }
    },
    touchmove(e) {
      console.log(e)
      if (this.freeze) {
        return
      }
      e.preventDefault()
      if (e.touches && e.touches.length > 0) {
        let obj = {
          x: e.touches[0].pageX,
          y: e.touches[0].pageY,
        }
        if (this.rotate) {
          obj.x = e.touches[0].pageY
          obj.y = this.windowHeight - e.touches[0].pageX
        }
        console.log(obj)
        this.drawing(obj)
      }
    },
    touchend(e) {
      if (this.freeze) {
        return
      }
      e.preventDefault()
      // alert(JSON.stringify(e))
      if (e.touches && e.touches.length > 0) {
        let obj = {
          x: e.touches[0].pageX,
          y: e.touches[0].pageY,
          type: 'end'
        }
        if (this.rotate) {
          obj.x = e.touches[0].pageY
          obj.y = this.windowHeight - e.touches[0].pageX
        }
        this.drawEnd(obj)
      }else {
        this.drawEnd({
          x: this.start.x,
          y: this.start.y,
          type: 'end'
        })
      }
    },
    setColor(item) {
      this.color = item
      this.optionType = null
    },
    setPen(item) {
      this.width = item
      this.optionType = null
    },
    penClick() {
      if (this.hideBar) {
        this.hideBar = false
        this.optionType = null
      } else {
        this.optionType = 'pen';
        this.writeType = 'pen'
      }
    },
    closeOption() {
      if(this.optionType !== 'hideBar') {
        this.optionType = null
      }
    },
    clearCanvas(type) {
      this.ctx.clearRect(0,0, this.windowWidth, this.windowHeight);
      this.$nextTick(() => {
        this.points = []
      })
      if (type !== 'socket' && (this.creator || this.edit)) {
        bus.$emit('emitClear')
      }
      this.writeType = 'pen'
    },
    onClear() {
      this.clearCanvas('socket')
    },
    removePoint(point) {
      for (let a = 0; a < this.points.length; a++) {
        const curr = this.points[a]
        if (this.getDistance(point, curr) <= 10) {
          curr.remove = true
        }
      }
    },
    pointChange(e) {
      console.log('变化', e)
    },
    emitWriting(point, type, optionType) {
      if (!this.edit && !this.creator) {
        return
      }
      const myPoint = {...point}
      const newPoint = {}
      // console.log(myPoint)
      if (!this.creator) {
        // if (this.rotate) {
        //   newPoint.y = myPoint.x / this.originalZoom
        //   newPoint.x = myPoint.y / this.originalZoom
        // } else {
          newPoint.y = myPoint.y / this.originalZoom
          newPoint.x = myPoint.x / this.originalZoom
        // }
      }else {
        newPoint.x = myPoint.x
        newPoint.y = myPoint.y
      }
      // console.log(myPoint)
      if (this.creator) {
        bus.$emit('writing', {
          type,
          point: newPoint,
          optionType,
          writeType: this.writeType,
          color: this.color,
          width: this.width,
          edit: this.edit
        })
      } else {
        bus.$emit('writing', {
          type,
          point: newPoint,
          optionType,
          writeType: this.writeType,
          color: this.color,
          width: this.width
        })
      }
    },
    getWriting(params) {
      const myPoint = {...params.point}
      // if (this.rotate) {
      //   params.point.y = myPoint.x * this.originalZoom
      //   params.point.x = myPoint.y * this.originalZoom
      // } else {
        params.point.x = myPoint.x * this.originalZoom
        params.point.y = myPoint.y * this.originalZoom
      // }
        if (params.edit !== undefined) {
          this.edit = params.edit
        }
      // console.log('接受参数', params)
      if (params.msgType === 'writing') {
        if (params.writeType === 'eraser') {
          this.writeType = 'eraser'
        } else {
          this.writeType = 'pen'
        }
        if (params.type === 'start') {
          this.optionType = params.optionType
          if (params.color) {
            this.color = params.color
          }
          if (params.width) {
            this.width = params.width
          }
          if (params.width === 20) {
            params.width = 25
          }
          if (params.width) {
            this.ctx.lineWidth = params.width
          }
          this.drawStart(params.point, true)
          if (this.optionType === 'hideBar') {
            this.hideBar = true
          } else {
            this.hideBar = false
          }
        } else if (params.type === 'writing') {
          this.drawing(params.point, true)
        } else if (params.type === 'end') {
          setTimeout(() => {
            this.drawEnd(params.point, true)
          }, 20)
        }
        this.freeze = true
        clearTimeout(this.freeze)
        setTimeout(() => {
          this.freeze = false
        }, 1000)
      }
    },
    showId() {
      const shareText = `画板链接：${url.shareUrl}?code=${this.canvasId}\n分享码：${this.canvasId}`
      this.copyText(shareText)
      alert(`${shareText}`)
    },
    emitPoint(targetId) {
      // console.log('emitPoint', this.points)
      bus.$emit('sendPoint', {points: this.points, width: this.windowWidth, height: this.windowHeight, targetId, color: this.color, edit: this.edit})
    },
    getPoint(params) {
      // console.log('数据', params)
      const originalWidth = params.width
      const originalHeight = params.height
      this.color = params.color || '#191919'
      if (params.edit !== undefined) {
        this.edit = params.edit
      }
      // 判断是否需要旋转
      if (originalWidth > originalHeight && this.windowWidth < this.windowHeight || originalWidth < originalHeight && this.windowWidth > this.windowHeight) {
        this.rotate = -90
      }
      // if (this.windowHeight > this.windowWidth) {
      //   width = originalSize[0]
      //   height = originalSize[1]
      // } else {
      //   width = originalSize[1]
      //   height = originalSize[0]
      // }
      // console.log(width, height)
      // 判断是宽撑满还是高撑满
      let zoomWidth = this.windowWidth / params.width
      let zoomHeighth = this.windowHeight / params.height
      if (this.rotate) {
        zoomWidth = this.windowWidth / params.height
        zoomHeighth = this.windowHeight / params.width
      }
      console.log(zoomWidth, zoomHeighth)
      this.originalZoom = zoomWidth > zoomHeighth ? zoomHeighth : zoomWidth
      // if (this.rotate) {
      //   this.windowWidth = originalHeight * this.originalZoom
      //   this.windowHeight = originalWidth * this.originalZoom
      // } else {
        this.windowWidth = originalWidth * this.originalZoom
        this.windowHeight = originalHeight * this.originalZoom
      // }
      this.$nextTick(() => {
        let canvas = document.querySelector('#my-canvas')
        this.ctx = canvas.getContext("2d");
        this.ctx.strokeStyle = this.color
        this.ctx.lineWidth  = this.width
        this.ctx.lineJoin = "round" // 重叠样式
        this.ctx.lineCap = "round" // 断点环境

        // this.ctx.moveTo(200,100);
        // this.ctx.lineTo(200,101);
        // this.ctx.stroke();
        // console.log(this.ctx)
        // bus.$on('pointChange', this.pointChange)
        setTimeout(() => {
          this.drawPoints(params.points)
        }, 100)
      })
    },
    drawPoints(points) {
      for(let a = 0; a < points.length; a++) {
        const point = {...points[a]}
        // console.log(point)
        const myPoint = {}
        // if (this.rotate) {
        //   myPoint.y = point.x * this.originalZoom
        //   myPoint.x = point.y * this.originalZoom
        // } else {
          myPoint.x = point.x * this.originalZoom
          myPoint.y = point.y * this.originalZoom
        // }
        if (point.type === 'start') {
          console.log(point.color)
          myPoint.color = point.color
          myPoint.width = point.width
          this.drawStart(myPoint, true)
          this.color = myPoint.color
          this.width = myPoint.width
        } else if (point.type === 'end') {
          this.drawEnd(myPoint, true)
        } else {
          this.drawing(myPoint, true)
        }
      }
    },
    copyText(text) {
      var textarea = document.createElement("textarea"); //创建input对象
      var currentFocus = document.activeElement; //当前获得焦点的元素
      var toolBoxwrap = document.getElementById('NewsToolBox'); //将文本框插入到NewsToolBox这个之后
      toolBoxwrap.appendChild(textarea); //添加元素
      textarea.value = text;
      textarea.focus();
      if (textarea.setSelectionRange) {
        textarea.setSelectionRange(0, textarea.value.length); //获取光标起始位置到结束位置
      } else {
        textarea.select();
      }
      let flag
      try {
        flag = document.execCommand("copy"); //执行复制
      } catch (eo) {
        flag = false;
      }
      toolBoxwrap.removeChild(textarea); //删除元素
      currentFocus.focus();
      return flag;
    },
    setPoints(value) {
      // this.points = value
      let canvas = document.querySelector('#my-canvas')
      this.ctx = canvas.getContext("2d");
      this.ctx.strokeStyle = this.color
      this.ctx.lineWidth  = this.width
      this.ctx.lineJoin = "round" // 重叠样式
      this.ctx.lineCap = "round" // 断点环境
      setTimeout(() => {
        this.drawPoints(value)
      }, 100)
    }
}

}
</script>

<style scoped>
.canvas-page{
  padding: 0;
  margin: 0;
  font-size: 0;
  width: 100%;
  /*height: 100%;*/
  display: flex;
  /*justify-content: center;*/
  /*align-items: center;*/
  background-color: #fff;
}
canvas{
  box-shadow: 0 0 6px 0 #999;
  transform-origin: left top;
  /*background-color: #efefef;*/
}
canvas.rotate{
  /*transform: rotateX(-90deg) translateY(-100%);*/
}
.tool-bar{
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 152px;
  transition: all 0.3s;
  transform-origin: center;

}
.hideBar{
  bottom: -14px;
  transform: scale(0.8) translateX(-60%);
  /*width: 122px;*/
}
.tool-bar>.tool-item{
  margin: 12px;
  cursor: pointer;
  position: relative;
}
.color-circle{
  width: 16px;
  height: 16px;
  margin: 5px;
  border: 2px #fff solid;
  border-radius: 50%;
  display: inline-block;
}
.curr-circle{
  width: 10px;
  height: 10px;
  border-width: 5px;
}
.icon{
  width: 30px;
  height: 30px;
  display: inline-block;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.icon.active{
  opacity: 1;
  background-color: #ededed;
}
.pen-icon{
  background-image: url('~@/assets/pen.png');
}
.eraser-icon{
  background-image: url('~@/assets/eraser.png');
  background-size: 90% 90%;
}
.options{
  position: absolute;
  top: -50px;
  width: 100%;
  /*min-width: 250px;*/
  transform: translateX(calc(-50% + 14px));
  border-radius: 4px;
  border: 1px solid #999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pen-width{
  width: 30px;
  border-radius: 4px;
  background-color: #191919;
  margin: 10px 4px;
}
.curr-pen{
  background-color: #ededed;
}
.clear{
  padding: 3px 5px;
  width: 50px;
}
.close{
  width: 20px;
  height: 10px;
  display: inline-block;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-image: url('~@/assets/close.png');
  opacity: 0.8;
  margin: 6px 3px;
}
.common-share{
  position: fixed;
  top: 8px;
  left: 8px;
  font-size: 24px;
  cursor: pointer;
}
.edit-switch{
  position: fixed;
  top: 8px;
  right: 8px;
  font-size: 14px;
  display: flex;
  align-items: center;
}
.edit-switch>span{
  margin-right: 8px;
}
</style>
